import { ApiService } from '../model/Api.model';
import { AxiosInstance } from 'axios';
import { IFillSelect } from '../interface/generic/IFillSelect';
import { ICourtTypeFull } from '../interface/court/ICourtTypeFull';

enum CourtTypeServiceEnum {
	getAll = '/',
	getById = '?idCourtType=',
	getTypes = '/types',
	save = '/'
}

export default class CourtTypeService extends ApiService {
	constructor(restClient: AxiosInstance) {
		super(restClient, '/court-type');
	}
	public getAll = async (): Promise<ICourtTypeFull[]> => await this.GET(CourtTypeServiceEnum.getAll);
	public getCourtType = async (type: string): Promise<ICourtTypeFull> => await this.GET(CourtTypeServiceEnum.getById + type);
	public getTypes = async (): Promise<IFillSelect[]> => await this.GET(CourtTypeServiceEnum.getTypes);
	public save = async (data: ICourtTypeFull): Promise<ICourtTypeFull> => await this.POST(CourtTypeServiceEnum.save, data);
}
